interface Props {
  status: 'connected' | 'disconnected' | 'syncing';
}

export function StatusDot({ status }: Props) {
  const syncing = status === 'syncing';
  const connected = status === 'connected' || syncing;

  const color = connected
    ? syncing ? 'var(--warning)' : 'var(--success)'
    : 'var(--slate-light)';

  return (
    <span
      className={connected ? (syncing ? '' : 'status-dot-connected') : 'status-dot-disconnected'}
      style={{
        display: 'inline-block',
        width: 8,
        height: 8,
        borderRadius: 4,
        background: color,
        boxShadow: connected && !syncing ? `0 0 0 3px ${color}22` : 'none',
        animation: syncing ? 'pulse 1.4s ease-in-out infinite' : 'none',
        flexShrink: 0,
      }}
    />
  );
}
